module.exports = __webpack_public_path__ + "static-v-shop/1765543399050/img/logo_master.c8bdcd8d.svg";